import configureStore from 'state/configureStore';

const { store: _store, persistor: _persistor } = configureStore();

export const store = _store;
export const persistor = _persistor;
